import { createElement } from 'react';
import type { IToolbarGlyphProps } from './IToolbarGlyphProps';
import { toolbarGlyphs } from './toolbarGlyphs';

/** Знак іконної кнопки панелі списку (прототип v4): SVG 16×16, обведення 1.8 кольором тексту, округлі кінці й з'єднання. */
export function ToolbarGlyph({ name }: IToolbarGlyphProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {toolbarGlyphs[name].map((s, i) => createElement(s.tag, { key: i, ...s.attrs }))}
    </svg>
  );
}
